import { ChevronRight } from "lucide-react";
import { Link, useLocation } from "react-router-dom";

const TOOL_NAMES: Record<string, string> = {
  cvr: "Monthly Project CVR",
  evm: "Earned Value Management",
  "target-cost": "Target Cost Calculator",
};

export function Breadcrumb() {
  const location = useLocation();
  const toolPath = location.pathname.split("/")[1];
  const toolName = TOOL_NAMES[toolPath];

  if (!toolName) return null;

  return (
    <nav className="flex items-center gap-2 text-sm" aria-label="Breadcrumb">
      <Link
        to="/"
        className="text-muted-foreground hover:text-foreground transition-colors"
      >
        Home
      </Link>
      <ChevronRight className="h-4 w-4 text-muted-foreground" />
      <span className="font-medium">{toolName}</span>
    </nav>
  );
}
